
const svg = require(`~/assets/brands/${process.env.AGENT}/logo.svg`);

export default {
	name: 'logoapp',
	data() {
		return {svg: typeof svg === 'string' ? svg : svg.default || ''};
	}
};
